import { render, staticRenderFns } from "./selectCity.vue?vue&type=template&id=10947cfe&"
import script from "./selectCity.vue?vue&type=script&lang=js&"
export * from "./selectCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports